<template>
  <qx-custom-form
    :noSubBtn="true"
    style="margin: 0; width: auto"
    ref="baseForm"
    :formData="baseForm"
  >
    <span class="oilCardNum-tip" slot="chooseOilCardNumTip">
      <span class="item">
        <span
          >类型：
          <span v-if="oilcardInfo.cardTypeName">{{
            oilcardInfo.cardTypeName
          }}</span>
          <span
            class="error"
            v-if="oilcardInfo.cardType && !oilcardInfo.cardTypeName"
            >无</span
          >
        </span>
      </span>
      <span class="item" v-if="itemData.paymentWay === 2"
        >充值：{{ oilcardInfo.cardBalance / 100 }} 元</span
      >
      <span class="item" v-else
        >理论金额：{{ oilcardInfo.cardBalance / 100 }} 元</span
      >
    </span>
  </qx-custom-form>
</template>

<script>
import { findOilCardByCardNum } from 'api/operate';
export default {
  props: {
    oilcardData: {
      type: Object,
      defatult: () => ({}),
    },
    oilcardIndex: {
      type: Number,
      default: -1,
    },
    itemData: {
      type: Object,
      defatult: () => ({}),
    },
  },
  computed: {
    oilcardInfo () {
      const oilcardInfo = this.oilcardData;
      this.$nextTick(() => {
        this.$refs.baseForm.setVal('chooseOilCardNum', this.oilcardData.oilCardNum || this.oilcardData.oilCarNum);
      });
      return oilcardInfo;
    },
  },
  data () {
    return {
      showOilCarInfo: false,
      cardTypeName: '',
      oilFee: 0,
      baseForm: {
        form: [
          {
            // label: '油卡卡号',
            // value: 'oilCardNum',
            // type: 'input',
            // onKeyup: (oilCardNum) => {
            //   this.findOilCardByCardNum(oilCardNum);
            // },

            label: '油卡卡号',
            value: 'chooseOilCardNum',
            type: 'el-autocomplete',
            valueKey: 'label',
            querySearchAsync: (queryString, cb) => {
              let res = [];
              if (queryString && queryString.length) {
                findOilCardByCardNum({ cardNum: queryString }).then((data) => {
                  for (let item of data) {
                    item.label = `${item.oilCarNum}（理论余额：${item.cardBalance / 100}元）`;
                  }
                  res = data;
                  cb(res);
                });
              }
              cb(res);
            },
            onSelect: async (item) => {
              if (item) {
                this.$refs.baseForm.setVal('chooseOilCardNum', item.oilCarNum);
                this.$emit('getOilCardInfo', item, this.oilcardIndex);
                this.$emit('getOilCardList', item);
              }
            },
          },
        ],
        rules: {
          chooseOilCardNum: [
            { validator: this.checkOilcardNum, trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    checkOilcardNum (rule, value, call) {
      setTimeout(() => {
        if (this.oilcardData.isNeedWarn) {
          call('平台服务商油卡，保存后请到付款核销-油卡充值页面发起充值。');
        } else {
          call();
        }
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped>
.oilCardNum-tip {
  margin-left: 16px;
  .item {
    display: inline-block;
    min-width: 150px;
    margin-right: 8px;
  }
}
</style>
